import { useState, useEffect } from 'react';
import { Country, State, City } from 'country-state-city';

export const useCountryStateCity = () => {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    setCountries(Country.getAllCountries());
  }, []);

  const getStatesOfCountry = (countryCode) => {
    setStates(State.getStatesOfCountry(countryCode));
    setCities([]);
  };

  const getCitiesOfState = (countryCode, stateCode) => {
    setCities(City.getCitiesOfState(countryCode, stateCode));
  };

  return {
    countries,
    states,
    cities,
    getStatesOfCountry,
    getCitiesOfState,
  };
};
